export const formatBodyForArticle = (text: string) => {
  return convertNewLinesToParagraphs(text);
};

export const convertNewLinesToParagraphs = (input: string) => {
  // すべての改行コードをUnixスタイルに統一
  const unifiedInput = input.replace(/\r\n|\r/g, "\n");

  const lines = unifiedInput.split("\n");
  const paragraphs = lines.map(
    (line) => `<p class="wysiwyg-font-size-large">${line}</p>`,
  );

  return paragraphs.join("");
};
